import { FC } from 'react';

import { Link } from '@dbt-labs/sourdough';

import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { MAX_PAGE_SIZE } from '@/hooks/discovery/apiConstants';
import { usePublicModelsPanelList } from '@/hooks/discovery/publicModels';
import { useLinkToExplorer } from '@/hooks/links';
import { useTargetEnvironmentType } from '@/hooks/useTargetEnvironmentType';
import { safeParseUniqueId } from '@/typings/parseUniqueId';

interface PanelDetailsProps {
  projectId: number | null;
}

export const ProjectPanelPublicModelsTab: FC<PanelDetailsProps> = ({ projectId }) => {
  const { accountId } = useDbtCloudAccount();

  const getTargetEnvironmentType = useTargetEnvironmentType();
  const publicModelsQuery = usePublicModelsPanelList({
    first: MAX_PAGE_SIZE,
    accountId,
    projectId,
  });

  const modelDetailsLink = useLinkToExplorer('resourceDetails');
  if (!accountId || !projectId) return null;

  if (!publicModelsQuery.data) {
    return null;
  }

  return (
    <>
      {/* <div className="relative mt-4">
        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
          <Icon icon={faSearch}></Icon>
        </span>
        <div className="w-full">
          <input
            className="w-full rounded-md py-2 pl-10 text-sm focus:outline-none"
            type="search"
            placeholder={'Search for model'}
            onChange={(e: any) => {
              const input: string = e.target.value;
              setSearchName(input);
            }}
          />
        </div>
      </div> */}

      <div className="mt-4">
        <ul className="space-y-2">
          {publicModelsQuery.data?.map((x, index) => {
            return (
              <li
                key={x.uniqueId}
                className={`-mx-2 px-2 py-1 ${index % 2 === 1 ? 'bg-bgBackground' : ''}`}
              >
                <Link
                  isInternal
                  to={modelDetailsLink({
                    accountId,
                    projectId,
                    dbtUniqueId: x.uniqueId,
                    // This will always return production since publicModelsEndpoint returns production
                    environmentType: getTargetEnvironmentType(x.environmentId),
                  })}
                  className="text-sm"
                >
                  {safeParseUniqueId(x.uniqueId).ok?.remainder || x.name}
                </Link>
                {/* Design originaly had "Last run At", but we don't have this because this is
                from definition state */}
                {/* <div className="text-xs text-fgAlt">
                  Run Generated At {formatDateCommon(new Date(x.runGeneratedAt)).utc}
                </div> */}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
